import { Select } from 'antd';
import './styles.scss';

const { Option } = Select;

const NONE_VALUE = '0';
const ALL = -2;

const toStr = (v) => (v == null ? '' : String(v));

const AllocationModalDropdown = ({
  allocation,
  setAllocation,
  label,
  type,
  items = [],
}) => {
  const currentValue = toStr(allocation?.[type]);

  const withNone = [
    { id: NONE_VALUE, name: 'None' },
    ...items.map((item) => ({
      id: toStr(item.id),
      name: item.name,
    })),
  ];

  const handleSelect = (value) => {
    const val = toStr(value);

    if (type === 'businessCaseId') {
      const nextBusinessCaseId = val === NONE_VALUE ? '0' : val;

      setAllocation((prev) => ({
        ...prev,
        businessCaseId: nextBusinessCaseId,
        entityId: null,
        scenarioId: [ALL],
        targetEntityId: null,
        targetScenarioId: [ALL],
      }));
      return;
    }

    if (type === 'entityId') {
      setAllocation((prev) => ({
        ...prev,
        entityId: val === NONE_VALUE ? null : val,
      }));
      return;
    }

    if (type === 'targetEntityId') {
      setAllocation((prev) => ({
        ...prev,
        targetEntityId: val === NONE_VALUE ? null : val,
      }));
      return;
    }

    if (type === 'accountId' || type === 'targetAccountId') {
      setAllocation((prev) => ({
        ...prev,
        [type]: val === NONE_VALUE ? '0' : val,
      }));
      return;
    }

    setAllocation((prev) => ({
      ...prev,
      [type]: val,
    }));
  };

  const normalizedValue =
    type === 'entityId' || type === 'targetEntityId'
      ? currentValue === '' || currentValue === '0'
        ? NONE_VALUE
        : currentValue
      : currentValue === ''
      ? NONE_VALUE
      : currentValue;

  return (
    <Select
      showSearch
      value={normalizedValue}
      placeholder={label}
      style={{ width: 224 }}
      optionFilterProp="children"
      onChange={handleSelect}
      dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
    >
      {withNone.map((item) => (
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      ))}
    </Select>
  );
};

export default AllocationModalDropdown;